import type { GameStatus } from '../game/game.ts';

/** Minimal M1 play HUD: stamina, movement state, control hints. The real HUD arrives in M4. */
export function createPlayHud(el: HTMLElement) {
  el.innerHTML = `
    <div class="ph-prompt" data-el="prompt">Click to play · <kbd>Esc</kbd> releases the mouse</div>
    <div class="ph-bar"><i data-el="stamina"></i></div>
    <div class="ph-state"><span data-el="creature"></span> · <span data-el="mode"></span> · <span data-el="speed"></span> m/s <span data-el="lock"></span></div>
    <div class="ph-keys" data-el="keys"></div>
    <div class="ph-room" data-el="room" hidden><span data-el="roomcode"></span> <button type="button" data-el="invite">Copy invite link</button></div>
    <div class="ph-net" data-el="net" hidden></div>`;
  const q = (k: string) => el.querySelector(`[data-el="${k}"]`) as HTMLElement;
  const KEYS = {
    keyboard:
      '<kbd>WASD</kbd> move · <kbd>Mouse</kbd> look · <kbd>Shift</kbd> dodge / hold to sprint · <kbd>Space</kbd> jump · <kbd>C</kbd> brace · <kbd>Tab</kbd> lock-on · <kbd>`</kbd> tuning',
    gamepad:
      '<kbd>LS</kbd> move · <kbd>RS</kbd> look · <kbd>B</kbd> dodge / hold to sprint · <kbd>A</kbd> jump · <kbd>LB</kbd> brace · <kbd>RS click</kbd> lock-on',
  };
  let lastKeys = '';
  let showNet = new URLSearchParams(location.search).has('netgraph');
  window.addEventListener('keydown', (e) => {
    if (e.code === 'KeyN' && !(e.target instanceof HTMLInputElement)) showNet = !showNet;
  });
  q('invite').addEventListener('click', async () => {
    const url = new URL(location.href);
    for (const k of ['net', 'netgraph', 'tune', 'creature']) url.searchParams.delete(k);
    try {
      await navigator.clipboard.writeText(url.toString());
      q('invite').textContent = 'Copied ✓';
    } catch {
      q('invite').textContent = url.toString();
    }
    setTimeout(() => {
      q('invite').textContent = 'Copy invite link';
    }, 1500);
  });
  return {
    render(s: GameStatus) {
      el.hidden = false;
      q('prompt').hidden = s.locked || s.device === 'gamepad';
      const pct = Math.max(0, Math.min(1, s.stamina / s.staminaMax));
      const bar = q('stamina');
      bar.style.transform = `scaleX(${pct})`;
      bar.dataset.low = String(pct < 0.25);
      q('creature').textContent = s.creature;
      q('mode').textContent = s.mode;
      q('speed').textContent = s.speed.toFixed(1);
      q('lock').textContent = s.lockOn ? '· 🎯 locked on' : '';
      q('room').hidden = !s.room;
      if (s.room) q('roomcode').textContent = `Room ${s.room}`;
      q('net').hidden = !(s.net && showNet);
      if (s.net && showNet) q('net').textContent = s.net;
      const keys = KEYS[s.device as keyof typeof KEYS] ?? KEYS.keyboard;
      if (keys !== lastKeys) {
        q('keys').innerHTML = keys;
        lastKeys = keys;
      }
    },
    error(msg: string) {
      el.hidden = false;
      el.innerHTML = `<div class="ph-error">Couldn't start the arena: ${msg.replace(/[<>&]/g, '')}</div>`;
    },
  };
}
